import { useTranslation } from 'react-i18next';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';

import { Button } from 'common/components/Button';
import { Card, CardContent } from 'common/components/Card';

interface IProps {
    count: number;
    loading?: boolean;
    onRequestBudget?: () => void;
}

export const PendingBudgetRequestsCard = ({
    count,
    loading,
    onRequestBudget,
}: IProps) => {
    const [translate] = useTranslation();

    return (
        <Card>
            <CardContent
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                    height: '100%',
                }}
            >
                <Typography variant="h4">
                    {translate('pendingBudgetRequestsCard.title')}
                </Typography>

                <Typography
                    sx={{
                        fontSize: '3.2rem',
                        fontWeight: 700,
                        lineHeight: 1.2,
                    }}
                >
                    {loading ? <Skeleton width={40} /> : count}
                </Typography>

                {onRequestBudget && (
                    <Button
                        fullWidth
                        color="primary"
                        sx={{ mt: 'auto' }}
                        variant="contained"
                        onClick={onRequestBudget}
                    >
                        {translate('pendingBudgetRequestsCard.requestButton')}
                    </Button>
                )}
            </CardContent>
        </Card>
    );
};
